import { DateFormat } from "@covertree/types";
import { addDays } from "date-fns";
import { formatInTimeZone, getTimezoneOffset } from "date-fns-tz";

export const START_DATE_TIMEZONE = "America/New_York";

// policy start date equals current day + 7 days
export const getPolicyStartDate = (
  dateFormat: DateFormat,
  timestamp: undefined | number = undefined
): string => {
  if (timestamp) {
    const date = new Date(timestamp);
    return formatInTimeZone(date, START_DATE_TIMEZONE, dateFormat);
  }

  const generatedTimestamp = new Date().getTime();
  const offset = getTimezoneOffset(START_DATE_TIMEZONE, generatedTimestamp);
  return formatInTimeZone(
    addDays(generatedTimestamp - offset, 7),
    START_DATE_TIMEZONE,
    dateFormat
  );
};
